import * as React from 'react';

export const ExternalLink = () => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' data-name='Icon / external Link' viewBox='0 0 21 21' aria-hidden='true'>
            <path data-name='External Link' d='M0 21V0h9.188v2.625H2.625v15.75h15.75v-6.563H21V21Zm8.259-10.116 8.26-8.259h-3.394V0H21v7.875h-2.625V4.48l-8.26 8.26Zm10.116-8.258Z' fill='#FFFFFF'/>
        </svg>
    );
};
